module.exports = new __parcel__URL__("bossfight_defeat_badge.55a0555f.png").toString();